module.exports = __webpack_public_path__ + "static/media/logo_navbar_dark_old.6f2ee763.png";